import Profile from "../components/Profile.vue";
import UsersManagement from "../components/UsersManagement.vue";
import UserCreation from "../components/UserCreation.vue";

export default [
  {
    path: "/users",
    name: "Utilisateurs",
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: "/users-management",
    name: "Gestion d'utilisateurs",
    component: UsersManagement,
    meta: { requiresAuth: true }
  },
  {
    path: "/user-creation",
    name: "Création d'utilisateur",
    component: UserCreation,
    meta: { requiresAuth: true }
  },
  {
    path: "/profile/:id",
    name: "Profile",
    component: Profile
  }
];
